import NotFound from "../../../containers/NotFound";
import ProductCatalog from "../../../containers/ProductCatalog";

import {Helmet} from "react-helmet";

import {connect} from "react-redux"

import { usePayeeStore } from "../../../contexts/PayeeStoreContext";

const Catalog = ({payeeCatalogs, payees}) => {
    const {payeeId="", payeeLoaded=false, payeeCatalogId="", catalogLoaded=false } = usePayeeStore()

    //listen to catalog indicated by the catalogId from the url params
    const payee = payees.payeesById[payeeId]
    const catalog = payeeCatalogs.payeeCatalogsById[payeeCatalogId]
    
    if (catalogLoaded && !catalog) return <NotFound />
    if (payeeLoaded && !payee) return <NotFound />
    if (catalog && !catalog.isActive) return <div className="margin-auto margin-top-1em width-fit-content card bold">{catalog.name} is not available</div>
    //if the payee and catalog have not yet been loaded, and one or both is falsy
    if (!catalog || !payee) return ""
    if (!payee.isActive) return <div>payee is not active</div>
    return (
        <div>
            <Helmet>
                <title>{payee.name}'s Store </title>
            </Helmet>
            <div className="">
                <ProductCatalog
                    payeeId={payee.id}
                    payeeName={payee.name}
                    payeeLogoImageUrl={payee.logoImageUrlMed}
                    payeeCatalogId={catalog.id}
                />
            </div>

        </div>
    )
}

const mapStateToProps = state => ({
    payeeCatalogs: state.payeeCatalogs,
    payees: state.payees,
})

export default connect(mapStateToProps)(Catalog)